import { useEffect, useState } from "react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Autoplay, Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { Col, Container, Row } from "../../components";
import { useContextHook } from "../../Context/ContextOPen";
import { iconsList, productList } from "../../Context/Lists";
import { content } from "../../lang/useLang";

const Products = () => {
  const { swiperIndex, direction } = useContextHook();
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [activeImageIndex, setActiveImageIndex] = useState(0);

  const openProductModal = (product) => {
    setSelectedProduct(product);
    setActiveImageIndex(0);
    document.body.style.overflow = "hidden";
  };

  const closeProductModal = () => {
    setSelectedProduct(null);
    document.body.style.overflow = "auto";
  };

  // تأثير الجسيمات المتحركة
  useEffect(() => {
    if (swiperIndex !== 2) return;
    closeProductModal();
    const canvas = document.getElementById("particle-canvas");
    if (!canvas) return;

    const ctx = canvas.getContext("2d");
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;

    const particles = [];
    const particleCount = 50;

    for (let i = 0; i < particleCount; i++) {
      particles.push({
        x: Math.random() * canvas.width,
        y: Math.random() * canvas.height,
        size: Math.random() * 3 + 1,
        speedX: (Math.random() - 0.5) * 0.5,
        speedY: (Math.random() - 0.5) * 0.5,
        color: `rgba(14, 165, 233, ${Math.random() * 0.3 + 0.1})`,
      });
    }

    function animate() {
      if (swiperIndex !== 2) return;

      ctx.clearRect(0, 0, canvas.width, canvas.height);

      particles.forEach((particle) => {
        particle.x += particle.speedX;
        particle.y += particle.speedY;

        if (particle.x < 0 || particle.x > canvas.width) particle.speedX *= -1;
        if (particle.y < 0 || particle.y > canvas.height) particle.speedY *= -1;

        ctx.beginPath();
        ctx.arc(particle.x, particle.y, particle.size, 0, Math.PI * 2);
        ctx.fillStyle = particle.color;
        ctx.fill();

        // توصيل الجسيمات القريبة
        particles.forEach((otherParticle) => {
          const dx = particle.x - otherParticle.x;
          const dy = particle.y - otherParticle.y;
          const distance = Math.sqrt(dx * dx + dy * dy);

          if (distance < 100) {
            ctx.beginPath();
            ctx.strokeStyle = `rgba(14, 165, 233, ${
              0.1 * (1 - distance / 100)
            })`;
            ctx.lineWidth = 0.5;
            ctx.moveTo(particle.x, particle.y);
            ctx.lineTo(otherParticle.x, otherParticle.y);
            ctx.stroke();
          }
        });
      });

      requestAnimationFrame(animate);
    }

    animate();

    return () => {
      // Cleanup
    };
  }, [swiperIndex]);

  return (
    <div
      className="min-h-screen bg-gradient-to-br from-slate-900 via-blue-900 to-cyan-900  py-5 relative overflow-hidden"
      style={{ direction }}
    >
      <br />
      {/* خلفية الجسيمات المتحركة */}
      {swiperIndex === 2 && (
        <canvas
          id="particle-canvas"
          className="absolute inset-0 w-full h-full opacity-40"
        />
      )}

      {/* تأثيرات ضوئية في الخلفية */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -top-40 -left-40 w-80 h-80 bg-cyan-500/10 rounded-full blur-3xl animate-pulse-slow"></div>
        <div className="absolute -bottom-40 -right-40 w-80 h-80 bg-blue-500/10 rounded-full blur-3xl animate-pulse-slow animation-delay-2000"></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-purple-500/5 rounded-full blur-3xl animate-pulse-slow animation-delay-4000"></div>
      </div>

      <Container className="relative z-10">
        <Row className="items-center">
          <Col md={12}>
            {/* العنوان مع أنيميشن مذهلة */}
            <div
              className={`te mb-5 transition-all duration-1000 ${
                swiperIndex === 2
                  ? "opacity-100 translate-y-0"
                  : "opacity-0 translate-y-10"
              }`}
            >
              <h1 className="text-4xl max-md:text-4xl font-bold mb-3 logo relative">
                <span
                  className="relative z-10"
                  style={{
                    background:
                      "linear-gradient(135deg, #22d3ee 0%, #3b82f6 50%, #6366f1 100%)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    backgroundClip: "text",
                    textShadow: "0 0 30px rgba(34, 211, 238, 0.5)",
                  }}
                >
                  {content.products}
                </span>
                <div className="absolute -inset-4 bg-gradient-to-r from-cyan-500/20 to-blue-500/20 blur-xl rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-1000"></div>
              </h1>

              <div className="w-32 h-1 bg-gradient-to-r from-cyan-400 to-blue-500 mx- rounded-full mb-4 shadow-lg shadow-cyan-500/30"></div>
            </div>

            {/* سلايدر المنتجات */}
            <div
              className={`transition-all duration-1000 delay-300 ${
                swiperIndex === 2 ? "opacity-100" : "opacity-0"
              }`}
            >
              <Swiper
                modules={[Navigation, Autoplay]}
                navigation={{
                  nextEl: ".swiper-button-next",
                  prevEl: ".swiper-button-prev",
                }}
                autoplay={{
                  delay: 4000,
                  disableOnInteraction: false,
                }}
                spaceBetween={15}
                slidesPerView={4}
                breakpoints={{
                  320: { slidesPerView: 1.2 },
                  640: { slidesPerView: 2 },
                  1024: { slidesPerView: 3 },
                  1280: { slidesPerView: 4 },
                }}
                style={{ direction: "ltr" }}
                className="py-5 relative "
              >
                {productList.map((product, index) => (
                  <SwiperSlide key={product.id}>
                    <div
                      className={`group relative bg-gradient-to-br from-white/10 to-white/5 rounded-3xl overflow-hidden shadow-2xl hover:shadow-cyan-500/20 border border-white/10 backdrop-blur-xl transform transition-all duration-1000 hover:scale-105 ${
                        swiperIndex === 2
                          ? "opacity-100 translate-y-0"
                          : "opacity-0 translate-y-10"
                      }`}
                      style={{
                        transitionDelay: `${index * 150}ms`,
                        background:
                          "linear-gradient(135deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.05) 100%)",
                      }}
                    >
                      {/* تأثير إشعاعي */}
                      <div className="absolute inset-0 bg-gradient-to-br from-cyan-500/5 via-transparent to-blue-500/5 opacity-0 group-hover:opacity-100 transition-all duration-700"></div>

                      {/* تأثير حدود متحركة */}
                      <div className="absolute -inset-0.5 bg-gradient-to-r from-cyan-500 to-blue-500 rounded-3xl opacity-0 group-hover:opacity-30 blur transition-all duration-500"></div>

                      {/* صورة المنتج */}
                      <div className="relative overflow-hidden h-64">
                        <img
                          src={product.image}
                          alt={product.title}
                          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                        />

                        {/* طبقة تدرج مع أنيميشن */}
                        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-70 group-hover:opacity-40 transition-all duration-500"></div>

                        {/* تأثير ضوئي */}
                        <div className="absolute inset-0 bg-gradient-to-br from-cyan-500/10 to-blue-500/10 opacity-0 group-hover:opacity-100 transition-all duration-700"></div>

                        {/* أيقونة العرض السريع */}
                        <button
                          onClick={() => openProductModal(product)}
                          className="absolute top-4 right-4 bg-black/50 hover:bg-cyan-600 text-white p-3 rounded-full shadow-2xl transform translate-y-2 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-500 hover:scale-110 hover:rotate-12 backdrop-blur-sm"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="w-5 h-5"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                            />
                          </svg>
                        </button>

                        {/* رقم المنتج */}
                        <div className="absolute top-4 left-4 bg-gradient-to-r from-cyan-500 to-blue-500 text-white text-sm font-bold w-8 h-8 rounded-full flex items-center justify-center shadow-lg">
                          {product.id}
                        </div>
                      </div>

                      {/* تفاصيل المنتج */}
                      <div className="p-6 flex flex-col gap-4 relative z-10">
                        <h3 className="text-xl font-bold text-white group-hover:text-transparent group-hover:bg-clip-text group-hover:bg-gradient-to-r group-hover:from-cyan-300 group-hover:to-blue-300 transition-all duration-500 text-center">
                          {content["products_" + product.id]}
                        </h3>

                        {/* الأيقونات */}
                        <div className="flex justify-center gap-2 flex-wrap">
                          {product.icons?.slice(0, 3).map((icon, iconIndex) => (
                            <div
                              key={iconIndex}
                              className="relative group/icon"
                            >
                              <div className="w-10 h-10 bg-white/10 rounded-xl flex items-center justify-center backdrop-blur-sm border border-white/20 group-hover/icon:bg-cyan-500/20 transition-all duration-300 hover:scale-110 hover:rotate-12">
                                <img
                                  src={iconsList?.["icon_" + icon]}
                                  alt=""
                                  className="w-5 h-5 filter brightness-0 invert"
                                />
                              </div>
                              <div className="absolute -bottom-8 left-1/2 transform -translate-x-1/2 bg-black/80 text-white text-xs px-2 py-1 rounded opacity-0 group-hover/icon:opacity-100 transition-all duration-300 whitespace-nowrap">
                                {
                                  content?.[
                                    "title_icon_" +
                                      product?.title_icons?.[iconIndex]
                                  ]
                                }
                              </div>
                            </div>
                          ))}
                          {product.icons && product.icons.length > 3 && (
                            <div className="relative group/icon">
                              <div className="w-10 h-10 bg-white/10 rounded-xl flex items-center justify-center backdrop-blur-sm border border-white/20 group-hover/icon:bg-cyan-500/20 transition-all duration-300">
                                <span className="text-white text-sm font-bold">
                                  +{product.icons.length - 3}
                                </span>
                              </div>
                            </div>
                          )}
                        </div>

                        {/* زر التفاصيل */}
                        <button
                          onClick={() => openProductModal(product)}
                          className="bg-gradient-to-r from-cyan-500/20 to-blue-500/20 text-cyan-100 border border-cyan-500/30 text-sm px-6 py-3 rounded-xl hover:shadow-lg transform hover:scale-105 transition-all duration-300 flex items-center justify-center gap-2 group/btn mt-2 backdrop-blur-sm hover:bg-cyan-500/30"
                        >
                          <span>{content["more"]}</span>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="w-4 h-4 transform group-hover/btn:translate-x-1 transition-transform duration-300"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M9 5l7 7-7 7"
                            />
                          </svg>
                        </button>
                      </div>
                    </div>
                  </SwiperSlide>
                ))}

                {/* أزرار التنقل المخصصة */}
                <div className="swiper-button-prev !w-14 !h-14 !bg-white/10 !shadow-2xl !rounded-full !text-cyan-300 hover:!bg-cyan-500/20 after:!text-lg backdrop-blur-sm border border-white/20"></div>
                <div className="swiper-button-next !w-14 !h-14 !bg-white/10 !shadow-2xl !rounded-full !text-cyan-300 hover:!bg-cyan-500/20 after:!text-lg backdrop-blur-sm border border-white/20"></div>
              </Swiper>
            </div>
          </Col>
        </Row>
      </Container>

      {/* مودال تفاصيل المنتج - تصميم مدمج */}
      {selectedProduct?.id && (
        <div className="fixed inset-0 bg-black/80 backdrop-blur-xl z-50 flex items-center justify-center p-4 animate-fadeIn">
          <div className="bg-gradient-to-br from-slate-900 via-blue-900 to-cyan-900 rounded-2xl shadow-2xl max-w-4xl w-full max-h-[85vh] overflow-y-scroll animate-scaleIn border border-cyan-500/20 relative">
            {/* تأثير خلفية المودال */}
            <div className="absolute inset-0 overflow-hidden">
              <div className="absolute -top-10 -right-10 w-20 h-20 bg-cyan-500/10 rounded-full blur-xl"></div>
              <div className="absolute -bottom-10 -left-10 w-20 h-20 bg-blue-500/10 rounded-full blur-xl"></div>
            </div>

            <div className="relative z-10 h-full flex flex-col">
              {/* الهيدر مع زر الإغلاق وزر PDF */}
              <div className="flex justify-between items-center p-4 border-b border-white/10">
                <h2 className="text-xl font-bold text-white text-center flex-1">
                  {content["products_" + selectedProduct.id]}
                </h2>

                <div className="flex items-center gap-2">
                  {/* زر الإغلاق */}
                  <button
                    onClick={closeProductModal}
                    className="bg-black/50 hover:bg-cyan-600 text-white p-2 rounded-full shadow-lg transition-all duration-300 hover:scale-110 hover:rotate-90 backdrop-blur-sm border border-white/20"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="w-5 h-5"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                  </button>
                </div>
              </div>

              {/* المحتوى الرئيسي */}
              <div className="flex-1 overflow-y-scroll">
                <div className="grid md:grid-cols-2 gap-6 p-6">
                  {/* قسم الصور */}
                  <div className="space-y-4">
                    {/* الصورة الرئيسية */}
                    <div className="relative bg-gradient-to-br from-cyan-900/50 to-blue-900/50 rounded-xl overflow-hidden h-48">
                      <img
                        src={selectedProduct.images?.[activeImageIndex]?.image}
                        alt={selectedProduct.title}
                        className="w-full h-full object-cover"
                      />
                    </div>

                    {/* معرض الصور المصغرة */}
                    {selectedProduct.images &&
                      selectedProduct.images.length > 1 && (
                        <div className="flex gap-2 justify-center overflow-x-auto pb-2">
                          {selectedProduct.images.map((img, index) => (
                            <button
                              key={index}
                              onClick={() => setActiveImageIndex(index)}
                              className={`flex-shrink-0 w-12 h-12 rounded-lg overflow-hidden border-2 transition-all duration-300 backdrop-blur-sm ${
                                activeImageIndex === index
                                  ? "border-cyan-400 shadow shadow-cyan-400/30 scale-110"
                                  : "border-white/20 hover:border-cyan-300"
                              }`}
                            >
                              <img
                                src={img.image}
                                alt={`${selectedProduct.title} ${index + 1}`}
                                className="w-full h-full object-cover"
                              />
                            </button>
                          ))}
                        </div>
                      )}
                  </div>

                  {/* قسم التفاصيل */}
                  <div className="space-y-6">
                    {/* الأيقونات */}
                    <div>
                      <h3 className="text-base font-semibold text-cyan-300 mb-3 ">
                        {content["feature_description1"]}
                      </h3>
                      <div className="grid grid-cols-3 gap-2">
                        {selectedProduct.icons
                          ?.slice(0, 6)
                          .map((icon, index) => (
                            <div
                              key={index}
                              className="flex flex-col items-center justify-center p-2 bg-white/5 rounded-lg border border-white/10 hover:border-cyan-400/30 transition-all duration-300 hover:transform hover:scale-105 hover:-translate-y-1 backdrop-blur-sm group/feature"
                            >
                              <div className="w-8 h-8 bg-gradient-to-br from-cyan-500/20 to-blue-500/20 rounded-lg flex items-center justify-center mb-1 group-hover/feature:from-cyan-500/30 group-hover/feature:to-blue-500/30 transition-all duration-300">
                                <img
                                  src={iconsList?.["icon_" + icon]}
                                  alt=""
                                  className="w-4 h-4 filter brightness-0 invert"
                                />
                              </div>
                              <div className="text-cyan-100 text-xs font-medium text-center leading-tight">
                                {
                                  content?.[
                                    "title_icon_" +
                                      selectedProduct?.title_icons?.[index]
                                  ]
                                }
                              </div>
                            </div>
                          ))}
                      </div>
                      {selectedProduct.icons &&
                        selectedProduct.icons.length > 6 && (
                          <div className="text-center mt-2">
                            <span className="text-cyan-300 text-sm">
                              +{selectedProduct.icons.length - 6} ميزات إضافية
                            </span>
                          </div>
                        )}
                    </div>

                    {/* المواصفات */}
                    <div>
                      <h3 className="text-base font-semibold text-cyan-300 mb-3 ">
                        {content["feature_description"]}
                      </h3>
                      <ul className="space-y-2 max-h-40 overflow-y-auto p-2">
                        {selectedProduct.descs?.map((desc, index) => (
                          <li
                            key={index}
                            className="flex items-start gap-2 text-cyan-100/90 text-sm animate-fadeInUp"
                            style={{ animationDelay: `${index * 50}ms` }}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              className="w-4 h-4 text-cyan-400 flex-shrink-0 mt-0.5"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                              />
                            </svg>
                            <span className=" flex-1 leading-relaxed">
                              {content?.["des_products_" + desc] || desc}
                            </span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* الأنيميشن المخصصة */}
      <style jsx>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }
        @keyframes scaleIn {
          from {
            opacity: 0;
            transform: scale(0.8) translateY(20px);
          }
          to {
            opacity: 1;
            transform: scale(1) translateY(0);
          }
        }
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        @keyframes pulse-slow {
          0%,
          100% {
            opacity: 0.3;
            transform: scale(1);
          }
          50% {
            opacity: 0.6;
            transform: scale(1.1);
          }
        }
        .animate-fadeIn {
          animation: fadeIn 0.5s ease-out;
        }
        .animate-scaleIn {
          animation: scaleIn 0.6s ease-out;
        }
        .animate-fadeInUp {
          animation: fadeInUp 0.6s ease-out forwards;
          opacity: 0;
        }
        .animate-pulse-slow {
          animation: pulse-slow 8s ease-in-out infinite;
        }
        .animation-delay-2000 {
          animation-delay: 2s;
        }
        .animation-delay-4000 {
          animation-delay: 4s;
        }
      `}</style>
    </div>
  );
};

export default Products;
